<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.36,10.176,13.826,3.642a4.719,4.719,0,0,0-3.359-1.391H6A3.754,3.754,0,0,0,2.251,6v4.466a4.719,4.719,0,0,0,1.391,3.359l6.534,6.534a4.756,4.756,0,0,0,6.718,0l3.466-3.466A4.756,4.756,0,0,0,20.36,10.176ZM19.3,15.833,15.833,19.3a3.255,3.255,0,0,1-4.6,0L4.7,12.765a3.271,3.271,0,0,1-.952-2.3V6A2.252,2.252,0,0,1,6,3.751h4.466a3.271,3.271,0,0,1,2.3.952L19.3,11.237A3.254,3.254,0,0,1,19.3,15.833ZM8.5,7.5a1,1,0,1,1-1-1A1,1,0,0,1,8.5,7.5Z"
    />
  </svg>
</template>
